import { Box } from '@mui/material';
import CampaginTable from '../../../common/CampaignTable';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import { useNavigate } from 'react-router-dom';

const PendPaymentCampaign = () => {
	let { fetchedMedias } = useContext(CampaignContext);
	let { t } = useTranslation();
	let navigate = useNavigate();
	const headerClassNames = 'text-xs bg-background-paper';

	let tabItem = [
		{
			api: '/admin/campaigns',
			postApi: '/admin/campaigns',
			status: 'payment_pend',
			showBtn: false,
			editAction: (id: number) => {
				navigate(`/campaigns/view/${id}?type=admin`);
			},
			viewAction: (id: number) => {
				navigate(`/campaigns/view/${id}?type=admin`);
			},
			view: true,
			edit: true,
			delete: true,
			columns: [
				{
					field: 'media',
					flex: 1,
					headerName: t('title'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						let filterMedia = fetchedMedias?.find(item => item.system_name === params.row.media);
						return filterMedia?.title;
					},
				},
				{
					field: 'content_type',
					flex: 1,
					headerName: t('content_type'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
				},
				{
					field: 'price',
					flex: 1,
					headerName: t('price'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return `${params.row.price} ${t('tooman')}`;
					},
				},
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'completed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-50 text-red-600' : params.row.status === 'confirmation_pend' ? 'bg-yellow-50 text-yellow-600' : params.row.status === 'queue_up' ? 'bg-blue-50 text-blue-600' : params.row.status === 'in_progress' ? 'bg-orange-50 text-orange-600' : params.row.status === 'payment_pend' ? 'bg-yellow-50 text-yellow-600' : 'bg-yellow-50 text-yellow-600'}`}>{params.row.status === 'completed' ? t('completed') : params.row.status === 'rejected' ? t('rejected') : params.row.status === 'confirmation_pend' ? t('confirmation_pend') : params.row.status === 'queue_up' ? t('queue_up') : params.row.status === 'in_progress' ? t('in_progress') : params.row.status === 'payment_pend' ? t('payment_pend') : t('pending_content')}</div>;
					},
				},
			],
			route: 'campaigns/view',
		},
	];
	return (
		<Box className="w-full">
			{/* <ShowModalCampaign open={open} status={status} id={id} showBtn={showBottomBtn} setOpen={setOpen} /> */}
			<CampaginTable tabItem={tabItem[0]} />
		</Box>
	);
};

export default PendPaymentCampaign;
